<form [formGroup]="familyMembersForm">
  <mat-form-field appearance="outline">
    <mat-label>{{ 'ABS-ChooseFamilyMembers' | translate }}</mat-label>
    <mat-select formControlName="familyMembers" multiple>
      @for (fm of familyMembers$ | async; track fm) {
        <mat-option [value]="fm.Id">{{ fm.FirstName + ' ' + fm.LastName }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</form>

@if (!!requiredFileTypes.length) {
  @for (fm of familyMembers$ | async | filter : filterWorkerFamilyMembers; track fm) {
    <div>
      <p>
        <b>{{ 'AddRequiredFilesForFamilyMember' | translate }}: {{ fm.FirstName + ' ' + fm.LastName }}</b>
      </p>
      <app-absence-form-file-upload
        [requiredFileTypes]="requiredFileTypes"
        [alreadySavedFiles]="(alreadySavedFamilyMembersFiles | findPurely : findWorkerFamilyMemberFiles(fm.Id))?.Files || []"
        (afterFileUpload)="afterFileUpload($event, fm.Id)"
      ></app-absence-form-file-upload>
    </div>
  }
}
